import User from '@/domain/user/user.entity';
import ProjectPersist from './project-persist.entity';
import { ProjectMember } from '@/domain/project/project-with-members.entity';

interface MemberTransfer {
  user: { username: string };
  roleId?: string;
  seniorityId?: string;
}

export default class ProjectPersistTransfer {
  id?: string;

  name: string;

  description: string;

  projectUsers: string[] = [];

  members: MemberTransfer[] = [];

  businessUnitId: string;

  costCenterId: string;

  manager: string;

  constructor(obj: ProjectPersist) {
    if (obj.id) this.id = obj.id;
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.projectUsers = this.getListOfUsernames(obj.projectUsers) || [];
    this.members = this.getMemberTransfers(obj.projectUsers, obj.members || []);
    this.businessUnitId = obj.businessUnitId || '';
    this.costCenterId = obj.costCenterId || '';
    this.manager = obj.manager.username || '';
  }

  public static of(value: any): ProjectPersistTransfer {
    return new ProjectPersistTransfer(value || {});
  }

  public static ofList(response: any): ProjectPersistTransfer[] {
    return response.data.map(this.of);
  }

  private getListOfUsernames(userList: User[]): string[] {
    return userList.map((user: User) => user.username);
  }

  private getMemberTransfers(userList: User[], members: ProjectMember[]): MemberTransfer[] {
    return userList.map((user: User) => {
      const existingMember = members.find(member => member.user.username === user.username);
      return {
        user: { username: user.username },
        roleId: existingMember ? existingMember.roleId : undefined,
        seniorityId: existingMember ? existingMember.seniorityId : undefined,
      };
    });
  }
}
